import { useRouter } from 'next/router';

export const t = (text) => {
  const lang = getLanguageByPath();
  switch (lang) {
    case 'hi':
      return translateHi[text] || text;
    default:
      return text;
  }
};
export const getLanguageByPath = () => {
  const router = useRouter();
  // const pathname = router.;
  // const lang = pathname?.split("/")[1] == "hi" ? "hi" : "en";
  return router.locale || router.defaultLocale;
};

export const translateHi = {
  'Baby Girl': 'बच्ची',
  'Meaning': 'अर्थ',
  'Unable to choose? Read these articles':
    'चुनने में असमर्थ ? इन लेखों को पढ़ें',
  'Gender': 'लिंग',
  'Origin': 'मूल',
  'Name Numerology': 'नाम अंकशास',
  'Religion': 'धर्म',
  'Boy': 'लड़का',
  'Girl': 'लड़की',
  'Name': 'नाम',
  'Horoscope (rashi)': 'राशिफल (राशि)',
  'Constellations (nakshatra)': 'नक्षत्र',
  '&': 'और',
  'Added named to your saved items': 'आपके सहेजे गए आइटम में नाम जोड़ा गया',
  'Share': 'शेयर',
};
